var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "vue_watermark", staticClass: "vue_watermark" },
    _vm._l(_vm.watermarkCells, function(cell, index) {
      return _c(
        "div",
        { key: index, staticClass: "watermark-cell", style: cell.style },
        _vm._l(_vm.texts, function(text, index) {
          return _c(
            "div",
            {
              key: text + index,
              staticStyle: { "text-align": "left", "white-space": "nowrap" }
            },
            [_vm._v("\n      " + _vm._s(text) + "\n    ")]
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08f2080a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f2080a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom_watermark/customWatermark.vue
// module id = null
// module chunks = 